const StateTranslate = ({ text, trasform }) => {
  // Traduzione degli stati
  let translatedText;
  let badgeClass;

  switch (text) {
    case "CREATE":
      translatedText = "Creato";
      badgeClass = "bg-primary"; // Colore per "Creato"
      break;
    case "OPEN":
      translatedText = "Aperto";
      badgeClass = "bg-info"; // Colore per "Aperto"
      break;
    case "CLOSED":
      translatedText = "Chiuso";
      badgeClass = "bg-danger"; // Colore per "Chiuso"
      break;
    case "ARCHIVED":
      translatedText = "Archiviato";
      badgeClass = "bg-secondary"; // Colore per "Archiviato"
      break;
    default:
      translatedText = "Sconosciuto";
      badgeClass = "bg-dark"; // Colore predefinito
  }

  // Trasformazioni del testo
  switch (trasform) {
    case "U":
      translatedText = translatedText?.toUpperCase();
      break;
    case "C":
      translatedText = translatedText?.charAt(0).toUpperCase() + translatedText?.slice(1).toLowerCase();
      break;
    case "L":
      translatedText = translatedText?.toLowerCase();
      break;
    default:
      // Nessuna trasformazione
      break;
  }

  return (
    <span className={`ml-2 badge ${badgeClass} text-white`}>
      {translatedText}
    </span>
  );
};

export default StateTranslate;
